import { defHttp, kedexOnlineHttp } from '@/utils/axios/index'
import {
  ElevatorBuildingRequest,
  ElevatorBuildingData,
  SiteListRequest,
  CommunityNameListRequest,
  UnitNameRequest,
  ElevatorNumRequest,
  ReadNumRequest,
  ElevatorBuildingDetailRequest,
  ElevatorBuildingDetailData,
  RoomCompanyItem,
  ElevatorCloudDetailData,
  RoomItem,
  DeviceListReponse
} from '../types/buildingElevator'
import type { Response } from '#/axios'
import { Region, UpdateElevatorRequest } from '../types/batchCreate'
import { isOnline } from '@/utils/auth'

enum Api {
  elevatorBuilding = '/api/elevatorBuilding/list',
  communityNameList = '/api/elevatorBuilding/communityNameList',
  communityNameListCloud = '/api/elevator/cloud/communityNameList',
  siteList = '/api/elevatorBuilding/siteList',
  siteListCloud = '/api/elevator/cloud/siteList',
  buildingNumList = '/api/elevatorBuilding/buildingNumList',
  buildingNumListCloud = '/api/elevator/cloud/buildingNumList',
  unitNameList = '/api/elevatorBuilding/unitNameList',
  unitNameListCloud = '/api/elevator/cloud/unitNameList',
  elematorNumList = '/api/elevatorBuilding/elevatorNumList',
  elematorNumListCloud = '/api/elevator/cloud/elevatorNumList',
  readNumList = '/api/elevatorBuilding/readNumList',
  readNumListCloud = '/api/elevator/cloud/readNumList',
  deleteElevatorBuilding = '/api/elevatorBuilding/delete',
  elevatorBuildingDetail = '/api/elevatorBuilding/detail',
  elevatorDetailCloud = '/api/elevator/cloudDetail',
  enableElevatorBuilding = '/api/elevatorBuilding/updateStatus',
  enableElevatorBuildingCloud = '/api/elevator/cloud/updateStatus',
  checkUpdateInfo = '/api/buildingUnit/checkUpdateInfo',
  checkUpdateInfoCloud = '/api/elevator/cloud/checkUpdateInfo',
  cityTreeSelect = '/api/cityCode/cityTreeSelect',
  roomCompany = '/api/elevator/roomCompany',
  cloudRoomList = '/api/elevator/cloudRoomList',
  onlineElevatorUpdate = '/api/elevator/updateInfo',
  hasAnyElevators = '/api/elevator/hasAnyElevators',
  queryExistDevice = '/api/elevator/getDeviceInfo',
  checkProcess = '/api/elevator/checkProcess',
  usedSiteList = '/api/elevatorBuilding/getZoneCodes',
  usedSiteListCloud = '/api/elevator/cloud/getZoneCodes'
}

enum CloudApi {
  elevatorBuilding = '/api/elevator/cloudList'
}

export const getElevatorBuilding = (data: ElevatorBuildingRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<ElevatorBuildingData>>({
      url: CloudApi.elevatorBuilding,
      data
    })
  }
  return defHttp.post<Response<ElevatorBuildingData>>({ url: Api.elevatorBuilding, data })
}

export const getSiteList = (data: SiteListRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.siteListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.siteList, data })
}

export const getCommunityNameList = (data: CommunityNameListRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.communityNameListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.communityNameList, data })
}

export const getBuildingNumList = (data: SiteListRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.buildingNumListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.buildingNumList, data })
}

export const getUnitNameList = (data: UnitNameRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.unitNameListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.unitNameList, data })
}

export const getElevatorNumList = (data: ElevatorNumRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.elematorNumListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.elematorNumList, data })
}

export const getReadNumList = (data: ReadNumRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<string[]>>({ url: Api.readNumListCloud, data })
  }
  return defHttp.post<Response<string[]>>({ url: Api.readNumList, data })
}

export const deleteElevatorBuilding = (data: string[]) => {
  return defHttp.post<Response<string>>({ url: Api.deleteElevatorBuilding, data })
}

export const enableElevatorBuilding = (params: any) => {
  if (isOnline()) {
    return kedexOnlineHttp.get<Response<string>>({ url: Api.enableElevatorBuildingCloud, params })
  }
  return defHttp.get<Response<string>>({ url: Api.enableElevatorBuilding, params })
}

export const getElevatorBuildingDetail = (data: ElevatorBuildingDetailRequest) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<ElevatorCloudDetailData>>({
      url: Api.elevatorDetailCloud,
      data
    })
  }
  return defHttp.post<Response<ElevatorBuildingDetailData>>({
    url: Api.elevatorBuildingDetail,
    data
  })
}

export const checkUpdateInfo = (data: any) => {
  if (isOnline()) {
    return kedexOnlineHttp.post<Response<ElevatorBuildingDetailData>>({
      url: Api.checkUpdateInfoCloud,
      data
    })
  }
  return defHttp.post<Response<ElevatorBuildingDetailData>>({ url: Api.checkUpdateInfo, data })
}

export const cityTreeSelect = () =>
  kedexOnlineHttp.get<Response<Region[]>>({ url: Api.cityTreeSelect })

export const roomCompany = (data) =>
  kedexOnlineHttp.post<Response<{ [property: string]: any; list: RoomCompanyItem[] }>>({
    url: Api.roomCompany,
    data
  })

export const cloudRoomList = (data) =>
  kedexOnlineHttp.post<Response<{ [property: string]: any; roomsList: RoomItem[] }>>({
    url: Api.cloudRoomList,
    data
  })

export const onlineElevatorUpdate = (data: UpdateElevatorRequest) =>
  kedexOnlineHttp.post<Response<string>>({ url: Api.onlineElevatorUpdate, data })

export const hasAnyElevators = () =>
  kedexOnlineHttp.get<Response<any>>({ url: Api.hasAnyElevators })

export const queryExistDevice = () =>
  kedexOnlineHttp.get<Response<DeviceListReponse>>({ url: Api.queryExistDevice })

export const checkProcess = () => kedexOnlineHttp.get({ url: Api.checkProcess })

export const getUsedSiteList = () => {
  if (isOnline()) {
    return kedexOnlineHttp.get<Response<any>>({ url: Api.usedSiteListCloud })
  }
  return defHttp.get<Response<any>>({ url: Api.usedSiteList })
}
